<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Выгрузки</template>
        <template #content>
          <form @submit.prevent="onSubmit" ref="addFieldsForm">
          <div class="p-fluid col-12 md:col-6">
            <div class="field">
              <FileUpload
                  mode="basic"
                  choose-label="Выберите файл"
                  name="file[]"
                  accept=".csv"
                  :auto="false"
                  :custom-upload="true"
                  @select="onFileSelect"
              ></FileUpload>
              <small class="text-gray-500 block mt-2">
                Выберите файл для проставления номера договора (PDL) / номера кредитной линии (ЛЗ).
                Документ должен иметь формат .csv и колонку со значением ЦБ УИДа.
              </small>
            </div>

            <div class="row p-0">
              <div class="col-5 p-0">
                  <label class="font-bold">Индекс колонки с ЦБ УИДом</label>
                  <InputText
                      v-model="initIndex"
                      required
                  ></InputText>
              </div>
            </div>
            <div class="field">
              <label class="font-bold">Почта для отправки результата</label>
              <InputText
                  v-model="emailTo"
                  required
              ></InputText>
            </div>
            <div class="row">
              <div class="col-12 p-0 mt-2 mb-2">
                <Checkbox
                    binary
                    inputId="isWriteToStartField"
                    v-model="isWriteToStart"
                />
                <label class="font-bold ml-1" for="isWriteToStartField">Добавлять поля в начало файла</label>
              </div>
            </div>
            <div class="row">
              <div class="col-5 p-0 ">
                <Button
                    type="submit"
                    class="p-button-success"
                    label="Отправить"
                ></Button>
              </div>
            </div>
          </div>
          </form>

          <div class="mt-5">
            <div class="flex align-items-center mb-3">
              <h3 class="m-0 mr-2">Созданные задания</h3>
              <Button
                  icon="pi pi-refresh"
                  class="p-button-text p-button-rounded p-button-sm"
                  :loading="tasksLoading"
                  @click="loadTasks"
                  aria-label="Обновить"
              ></Button>
            </div>
            <DataTable :value="tasks" :loading="tasksLoading" stripedRows responsive-layout="scroll">
              <template #empty>
                <div style="text-align: center"><span>Нет данных</span></div>
              </template>
              <Column field="id" header="ID задания" style="width: 10%; text-align: center;" headerStyle="text-align: center;"></Column>
              <Column field="email" header="Email" style="text-align: center;" headerStyle="text-align: center;"></Column>
              <Column field="status" header="Статус" style="text-align: center;" headerStyle="text-align: center;">
                <template #body="{data}">
                  <Tag :severity="statusSeverity(data.status)" :value="statusLabel(data.status)"></Tag>
                </template>
              </Column>
              <Column field="createdAt" header="Создано" style="text-align: center;" headerStyle="text-align: center;">
                <template #body="{data}">
                  {{ formatDate(data.createdAt) }}
                </template>
              </Column>
              <Column header="Ссылки" style="text-align: center;" headerStyle="text-align: center;">
                <template #body="{data}">
                  <a
                      v-if="data.status === 'done' && data.downloadUrl"
                      :href="data.downloadUrl"
                      class="text-primary"
                  >
                    <i class="pi pi-file mr-1"></i>CSV
                  </a>
                  <span v-else class="text-gray-400">—</span>
                </template>
              </Column>
            </DataTable>
            <small class="text-gray-500 block mt-2">
              Ссылки становятся доступны, когда задание перейдёт в статус «Готово». Письмо со ссылками также придёт на указанный email.
            </small>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox'
import Tag from 'primevue/tag'
import AddDataToFileService from "@/service/AddDataToFileService";
import FilterDateService from "@/service/FilterDateService";

export default {
  name: "AddFields",
  components: { Checkbox, Tag },
  data() {
    return {
      initFile: null,
      emailTo: null,
      initIndex: null,
      isWriteToStart: true,
      tasks: [],
      tasksLoading: false,
    }
  },
  mounted() {
    this.loadTasks()
  },
  methods: {
    loadTasks() {
      this.tasksLoading = true
      AddDataToFileService.getTasks().then((res) => {
        this.tasks = Array.isArray(res) ? res : []
      }).catch(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось загрузить список заданий',
          life: 4000
        })
      }).finally(() => {
        this.tasksLoading = false
      })
    },
    formatDate(date) {
      if (!date) {
        return ''
      }
      return FilterDateService.dateToString(date)
    },
    statusLabel(status) {
      const map = {
        queued: 'В очереди',
        in_progress: 'В процессе',
        done: 'Готово',
        error: 'Ошибка',
      }
      return map[status] ?? status
    },
    statusSeverity(status) {
      const map = {
        queued: 'info',
        in_progress: 'warning',
        done: 'success',
        error: 'danger',
      }
      return map[status] ?? 'info'
    },
    onFileSelect(event) {
      this.initFile = event.files[0];
    },
    onSubmit() {
      if (!this.initFile) {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Выберите файл',
          life: 4000
        })
        return
      }

      const form = this.$refs.addFieldsForm;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData();

      formData.append("initFile", this.initFile);
      formData.append("emailTo", this.emailTo);
      formData.append("initIndex", this.initIndex);
      formData.append("isWriteToStart", this.isWriteToStart ? "true" : "false");

      AddDataToFileService.processFile(formData).then((res) => {
        if (res?.code === 500 && res?.message !== null) {
          this.$toast.add({
            severity: 'error',
            summary: 'Ошибка сохранения файла',
            detail: res.error,
            life: 4000
          })
          return
        }
        this.$toast.add({
          severity: 'success',
          summary: 'Файл добавлен в очередь',
          detail: 'Письмо с файлом будет направлено на указанную почту',
          life: 4000
        })
        this.loadTasks()
      }).catch((err) => {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка сохранения файла',
          detail: err.message,
          life: 4000
        })
      })
    }
  }
}
</script>